import { IAdserverCampaign } from '~/src/dash/api/campaign/campaign';
import { CreativeTypeMediafile, CreativeTypeVast } from '~/src/dash/globals/constants';

export function getCreativeType(campaign?: IAdserverCampaign): string {
  // if campaign is undefined, default creativeType to be vast
  if (!campaign) {
    return CreativeTypeVast;
  }
  // or else check whether first creative contains global mediafile or local mediafile, if it exists, it's mediafile type of creative
  for (const creative of campaign.AdserverCreatives) {
    if (creative.AdserverGlobalMediafileIDs.length > 0) {
      return CreativeTypeMediafile;
    }
  }
  // if it campaign.Creatives doesn't exist, default to mediafile type of creative
  if (campaign.AdserverCreatives.length <= 0) {
    return CreativeTypeMediafile;
  }
  return campaign.AdserverCreatives[0].AdserverGlobalVastID === undefined
    ? CreativeTypeMediafile
    : CreativeTypeVast;
}
